import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { SiteImportFormData } from '../../../../schemas/siteImportSchema';

const NotesField: React.FC = () => {
  const { control, setValue } = useFormContext<SiteImportFormData>();
  const notes = useWatch({ control, name: 'notes' }) ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue('notes', event.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <TextField
      label="Notes"
      value={notes}
      onChange={handleChange}
      multiline
      rows={3}
      fullWidth
      inputProps={{ 'data-testid': 'site-notes-input' }}
    />
  );
};

export default NotesField;
